import { toString1n9qg6fb0b5i8 as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var KeyCodesClass;
function KeyCodes() {
  if (KeyCodesClass === VOID) {
    class $ {
      letter_qks4hj_k$(char) {
        // Inline function 'kotlin.text.uppercase' call
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.unsafeCast' call
        return 'Key' + toString(char).toUpperCase();
      }
      get_space_iyncv1_k$() {
        return 'Space';
      }
      get_enter_iqxcq7_k$() {
        return 'Enter';
      }
    }
    initMetadataForObject($, 'KeyCodes');
    KeyCodesClass = $;
  }
  return KeyCodesClass;
}
var KeyCodes_instance;
function KeyCodes_getInstance() {
  return KeyCodes_instance;
}
//region block: init
KeyCodes_instance = new (KeyCodes())();
//endregion
//region block: exports
export {
  KeyCodes_instance as KeyCodes_instance1xpu3tad1ataj,
};
//endregion

//# sourceMappingURL=KeyCode.commonHtml.mjs.map
